import { useNavigate } from 'react-router-dom';
import { Menu, LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function AdminHeader({ onMenuClick }) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await signOut();
    navigate('/admin/login', { replace: true });
  }

  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 md:px-8 sticky top-0 z-20">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="md:hidden text-[#00384D] hover:text-[#007A96] -ml-1 p-1"
          aria-label="Open menu"
        >
          <Menu className="h-5 w-5" />
        </button>
        <div>
          <p className="text-[#00384D] font-semibold text-[15px] leading-tight tracking-tight">
            Admin Portal
          </p>
          <p className="text-slate-400 text-xs leading-tight hidden sm:block mt-0.5">
            Western Cape District — Church of the Nazarene
          </p>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <div className="hidden sm:flex items-center gap-2.5 pr-4 border-r border-slate-200">
          <div className="h-7 w-7 rounded-full bg-[#00384D]/10 flex items-center justify-center">
            <span className="text-[#00384D] text-[11px] font-semibold">
              {user?.email?.[0]?.toUpperCase() || 'A'}
            </span>
          </div>
          <span className="text-sm text-slate-600">{user?.email}</span>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-[#C21E26] hover:border-[#C21E26]/40 border border-slate-200 rounded-md px-3 py-1.5 transition-colors"
        >
          <LogOut className="h-[15px] w-[15px]" strokeWidth={2} />
          <span className="hidden sm:inline">Logout</span>
        </button>
      </div>
    </header>
  );
}
